import widgetTypes from './widgetTypes';
export default widgetTypes;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/index.js